import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import RootLayout from '../Pages/RootLayout';
import Dashboard from '../Pages/Dashboard';
import AllOrders from '../Pages/Orders';
import AddOrders from '../Pages/Orders/AddOrders';
import ConfirmOrders from '../Pages/Orders/ConfirmOrders';
import User from '../Pages/User';
import Login from '../Pages/Auth/Login';
import { useSelector } from 'react-redux';
import PrintOrders from '../Pages/Orders/PrintOrders';
import BulkUpdate from '../Pages/Orders/BulkUpdate';

function Routing() {

    const token = useSelector(state => state.auth.token);
    const role = useSelector(state => state.auth.role);

    const isAdmin = token && role === "admin";
    const isUser = token && role !== "admin";

    return (
        <BrowserRouter>
            <Routes>

                {/* ✅ Login Routes */}
                {!token && (
                    <>
                        <Route path="/login" element={<Login />} />
                        <Route path="*" element={<Navigate to="/login" />} />
                    </>
                )}

                {/* ✅ Admin Routes */}
                {isAdmin && (
                    <>
                        <Route path="/portal" element={<RootLayout />}>
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="update-orders" element={<AllOrders />} />
                            <Route path="add-orders" element={<AddOrders />} />
                            <Route path="print-orders" element={<PrintOrders />} />
                            <Route path="confirm-orders" element={<ConfirmOrders />} />
                            <Route path="user" element={<User />} />
                            <Route path="bulk-update" element={<BulkUpdate />} />

                        </Route>

                        <Route path="*" element={<Navigate to="/portal/dashboard" />} />
                    </>
                )}

                {/* ✅ Non Admin (only orders access) */}
                {isUser && (
                    <>
                        <Route path="/portal" element={<RootLayout />}>
                            <Route path="update-orders" element={<AllOrders />} />
                            <Route path="add-orders" element={<AddOrders />} />
                            <Route path="print-orders" element={<PrintOrders />} />
                            <Route path="confirm-orders" element={<ConfirmOrders />} />
                            <Route path="bulk-update" element={<BulkUpdate />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/portal/update-orders" />} />
                    </>
                )}

            </Routes>
        </BrowserRouter>
    );
}

export default Routing;
